import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import Marquee from "@/components/Marquee";
import { FadeIn, ClipReveal, Eyebrow } from "@/components/Reveal";
import { useSiteContent } from "@/hooks/useSiteContent";
import { IMAGES, SERVICES, MARQUEE_ITEMS, SOA } from "@/data/content";

export default function ServiziPage() {
  const { serviceImage } = useSiteContent();
  return (
    <>
      <PageHero
        eyebrow="Attività e servizi"
        lines={["Ingegneria", <span key="c" className="text-outline">del territorio</span>]}
        description="Operiamo nel settore dell'edilizia con particolare specializzazione in sei ambiti di cantiere, dal sottosuolo alle pareti rocciose verticali."
        image={IMAGES.drillFence}
      />

      <section className="py-24 lg:py-32" data-testid="servizi-list">
        <div className="mx-auto w-full max-w-7xl space-y-24 px-5 sm:px-8 lg:space-y-32">
          {SERVICES.map((s, i) => {
            const even = i % 2 === 1;
            return (
              <div
                key={s.id}
                className={`grid items-center gap-10 lg:grid-cols-2 lg:gap-20 ${even ? "lg:[&>*:first-child]:order-2" : ""}`}
                data-testid={`servizio-block-${s.id}`}
              >
                <ClipReveal>
                  <div className="relative overflow-hidden group">
                    <img
                      src={serviceImage(s.id)}
                      alt={s.fullTitle}
                      className="aspect-[4/3] w-full object-cover transition duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 border border-white/10" />
                    <p className="absolute left-5 top-5 soa-gold px-3 py-1.5 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-brand-slate">
                      {s.tag}
                    </p>
                  </div>
                </ClipReveal>
                <div>
                  <FadeIn>
                    <p className="font-mono text-xs text-brand-cyan">0{i + 1} / 06</p>
                    <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl">
                      {s.fullTitle}
                    </h2>
                    <p className="mt-7 max-w-xl text-base leading-relaxed text-slate-400 sm:text-lg">
                      {s.desc}
                    </p>
                  </FadeIn>
                  <FadeIn delay={0.15}>
                    <Link
                      to="/contatti"
                      data-testid={`servizio-cta-${s.id}`}
                      className="group mt-9 inline-flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-brand-ice transition hover:text-white"
                    >
                      Richiedi informazioni
                      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </Link>
                  </FadeIn>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="border-t border-white/10 bg-brand-teal py-20 lg:py-24" data-testid="servizi-soa">
        <div className="mx-auto w-full max-w-7xl px-5 sm:px-8">
          <Eyebrow>Qualifiche</Eyebrow>
          <FadeIn delay={0.05}>
            <h2 className="mt-6 font-display text-3xl font-bold uppercase tracking-tight sm:text-5xl">
              Attestazione SOA per le categorie
            </h2>
          </FadeIn>
          <div className="mt-10 flex flex-wrap gap-3">
            {SOA.map((c, i) => (
              <FadeIn key={c.code} delay={0.04 * i} amount={0.3}>
                <p
                  data-testid={`servizi-soa-chip-${c.code.replace(/\s/g, "").toLowerCase()}`}
                  className="border border-brand-gold/40 px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] text-brand-gold"
                >
                  {c.code} {c.level}
                </p>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <Marquee items={MARQUEE_ITEMS} />
    </>
  );
}
